import React, { useState } from "react";
import { Button, Form, FormGroup, Input, FormText } from "reactstrap";
import axios from "axios";

const UploadPage = ({ reFetch }) => {
  const [imgFile, setImgFile] = useState(null);

  const [previewImage, setPreviewImage] = useState(null);
  const [message, setMessage] = useState("");

  const handleSubmitFile = (e) => {
    e.preventDefault();
    // const jwt = localStorage.getItem("token");
    const myData = new FormData();
    myData.append("image", imgFile);
    axios({
      method: "POST",
      url: "https://aqueous-plains-06808.herokuapp.com/api/v1/images/",
      headers: {
        "content-type": "application/json",
      },
      data: myData,
    })
      // axios
      //   .post("https://aqueous-plains-06808.herokuapp.com/api/v1/images/", myData, {
      //     headers: { Authorization: `Bearer ${jwt}` },
      //   })
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setMessage("Image Uploaded Successfully!");
          setPreviewImage(null);
          setImgFile(null);
          reFetch();
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  return (
    <div
      className="container my-3 text-center p-3"
      style={{ border: "2px solid grey", borderRadius: "10px" }}
    >
      <Form onSubmit={handleSubmitFile}>
        <FormGroup>
          <Input
            type="file"
            name="image-file"
            multiple="false"
            onChange={(e) => {
              setImgFile(e.target.files[0]);
              setPreviewImage(URL.createObjectURL(e.target.files[0]));
            }}
          />
          <div style={{ zIndex: "-1" }} className="card">
            {previewImage ? (
              <img src={previewImage} width="50%" height="50%" alt="img" />
            ) : (
              <h5 className="text-center">
                {message ? message : "Preview Live"}
              </h5>
            )}
          </div>
          <FormText color="muted">
            Make sure the image being uploaded is a supported format.
          </FormText>
        </FormGroup>
        <Button type="submit" color="primary">
          Upload
        </Button>
      </Form>
    </div>
  );
};

export default UploadPage;
